/**
 * LA BARRA DE REGRESO (CONTRATO-VISTA-PANEL-T1, Ares #42092; el ejemplo de Josse: "volver al tablero").
 *
 * Hasta hoy cada vista copiaba `<a href="#/" class="back-link">&larr; Dashboard</a>` (46 vistas, medido en main
 * bbdf2bf). Esta pieza arma ese mismo enlace: por defecto vuelve al tablero; si la vista vuelve a otro lugar
 * (Negocios, Instrucciones, el asistente de presupuestos...) lo recibe en `volverA` y `texto`, no con un enlace propio.
 * La clase .back-link no cambia, asi que se ve igual y layout.css lo sigue escondiendo en role-client (salvo enfoque).
 *
 * @module presentation/shared/regreso
 */
import { esc } from './texto.js';

/**
 * @param {object} [o]
 * @param {string} [o.volverA='#/'] la ruta del regreso (o 'javascript:history.back()' para volver a la anterior)
 * @param {string} [o.texto='Dashboard'] lo que dice despues de la flecha
 * @param {string} [o.atributos] atributos extra ya armados (p. ej. 'data-presu-volver')
 */
export function regresoHtml({ volverA = '#/', texto = 'Dashboard', atributos = '' } = {}) {
  const extra = atributos ? ` ${atributos}` : '';
  return `<a href="${esc(volverA)}" class="back-link"${extra}>&larr; ${esc(texto)}</a>`;
}
